// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const hi: ChromeTranslations = {
  'nav.nextPage': 'अगला पृष्ठ →',
  'nav.previousPage': '← पिछला पृष्ठ',
  'nav.continueToLevel': 'स्तर पर जारी रखें →',
  'nav.backToMenu': 'मेन्यू पर वापस →',
  'howto.page': '{total} में से पृष्ठ {n}',
  'options.title': 'विकल्प',
  'ui.language': 'भाषा',
};
